/**
 * Storico dei trasferimenti fra canali.
 *
 * Non esiste nel prototipo (§7.1 n.5) ma e nell'inventario di parita: va
 * preservato tale e quale a `TicketDetail.tsx:732-751`, cioe gruppo di
 * partenza, gruppo di arrivo, motivo (quando c'e) e data.
 */
import React, { useId } from 'react';
import { formatDate } from '../constants';
import type { TicketTransfer } from '../../../services/supportApi';

export interface TransfersCardProps {
  transfers?: TicketTransfer[];
}

const TransfersCard: React.FC<TransfersCardProps> = ({ transfers }) => {
  const headingId = useId();
  const list = transfers || [];
  if (list.length === 0) return null;

  return (
    <section className="s3-card s3-ctx" aria-labelledby={headingId}>
      <h3 id={headingId} className="s3-h3">Trasferimenti</h3>
      <ol className="s3-tl">
        {list.map((t, i) => (
          <li key={`${t.at}-${i}`} className="s3-tl__item">
            <span className="s3-tl__dot s3-tl__dot--warn" aria-hidden="true" />
            <div className="s3-tl__body">
              <div className="s3-tl__txt">
                {t.fromGroupId?.nome || '—'} → {t.toGroupId?.nome || '—'}
              </div>
              {t.motivo && <div className="s3-tl__note">{t.motivo}</div>}
              <div className="s3-meta">{formatDate(t.at)}</div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default TransfersCard;
